import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-zinc-900 border-y border-zinc-800" data-id="element-21" data-mp="22elmevptxplz">
      <div className="max-w-5xl mx-auto" data-id="element-22" data-mp="1ydi6yabp1vla">
        <div className="text-center mb-16" data-id="element-23" data-mp="1yejh8ckvye1y">
          <p className="text-amber-400 font-display font-extrabold tracking-widest uppercase mb-2" data-id="element-24" data-mp="1ao7ctboumzg4">
            Included today at no additional cost
          </p>
          <h2 className="flex items-center justify-center gap-3 text-4xl md:text-5xl font-black uppercase text-white" data-id="element-25" data-mp="15r76czo37uoh">
            <Gift className="text-amber-400 shrink-0 w-9 h-9 md:w-11 md:h-11" aria-hidden="true" data-id="element-26" data-mp="1jilt9hl48g0t" />
            <span data-id="element-27" data-mp="1eo7porwav2l2">
              5 Professional <span className="text-amber-400" data-id="element-28" data-mp="qzojqj0q31w5">MMA Coaching</span> Bonus Guides
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-29" data-mp="my36uxo6unly">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-zinc-950 border border-zinc-800 rounded-2xl p-8 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-30" data-mp="29rbeaot76tux" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-amber-400 text-zinc-950 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-display font-extrabold text-sm" data-id="element-31" data-mp="1vrikgkmdjxiq">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-amber-400/10 border border-amber-400/40 rounded-full flex items-center justify-center text-amber-400 mb-4" data-id="element-32" data-mp="25rj8gjv6v1t9">
                <Gift size={24} aria-hidden="true" data-id="element-33" data-mp="3h5mxdbmx5zrg" />
              </div>
              <h3 className="text-xl font-black uppercase mb-2 pr-28 text-white" data-id="element-34" data-mp="3h3tqpwcb3fjg">{bonus.title}</h3>
              <p className="text-zinc-200 text-sm font-semibold mb-4 border-l-4 border-amber-400 pl-4" data-id="element-35" data-mp="1h1kfy6hjr8zg">
                {bonus.subtitle}
              </p>

              {bonus.bulletsLabel && <p className="text-zinc-400 text-sm mb-3 leading-relaxed" data-id="element-36" data-mp="1q3agq2xbjk9w">{bonus.bulletsLabel}</p>}
              {bonus.bullets.length > 0 && <ul className="grid grid-cols-2 gap-x-4 gap-y-2 mb-6" data-id="element-37" data-mp="yc4dveq7r8gx">
                  {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2.5" data-id="element-38" data-mp="tf48z753obre">
                      <CheckCircle2 size={16} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-39" data-mp="175hbgtz82y9c" />
                      <span className="text-zinc-300 text-sm" data-id="element-40" data-mp="12dg3vld01vpn">{bullet}</span>
                    </li>)}
                </ul>}

              {bonus.flow && <div className="mb-6" data-id="element-41" data-mp="ao4ke71ip3yn">
                  {bonus.flowLabel && <p className="text-zinc-400 text-sm mb-3" data-id="element-42" data-mp="iuykewwl1dr">{bonus.flowLabel}</p>}
                  <FlowSteps steps={bonus.flow} align="start" data-id="element-43" data-mp="5amsmzf9pp8n" />
                </div>}

              {bonus.closing && <p className="text-amber-400 font-semibold text-sm mt-auto pt-4 border-t border-zinc-800" data-id="element-44" data-mp="3ms5xucc3jljs">
                  {bonus.closing}
                </p>}
            </motion.article>)}
        </div>
      </div>
    </section>;
}